import { Color, Vector2 } from "three";
import { Maps, useMaterial, useMeshPhysicalMaterial } from "@utils/useMaterial";

/* Textures - Modify as needed */
const maps: Partial<Maps> = {
    map: ["T_CorrugatedCardboardEdge_Light_A.jpg", {
        repeat: new Vector2(2.5, 12.2),
        offset: new Vector2(0.0, -0.25),
    }],
    aoMap: ["T_Liner_AO.jpg", {
        channel: 1,
    }]
};

/* Preload textures */
useMaterial.preload(maps);

export default function useMat() {
    /* Create Material - Modify as needed */
    return useMeshPhysicalMaterial(maps, {
        color: new Color("#FFFFFF"),
        metalness: 0,
        roughness: 0.9,
        normalScale: new Vector2(2, 2),
        envMapIntensity: 1,
    });
}